<template>
  <b-card class="standardpage reports">
    <b-card-header>
      <b-row align-v="top" no-gutters>
        <b-col>
          <i class="fa fa-gbp fa-2x mr-1 text-primary"></i>
          <span class="h4 ml-1"
            >{{ selection[0].yourref }} invoices, spent:
            <span class="text-primary">{{
              selection[0].spent | currency("£")
            }}</span>
            of
            <span class="text-primary">{{
              selection[0].value | currency("£")
            }}</span></span
          >
        </b-col>
      </b-row>
    </b-card-header>
    <b-alert :show="unreconciled" variant="danger" class="mt-2">
      <b-row align-v="center" no-gutters
        ><b-col cols="auto mr-3">
          <i class="fa fa-info-circle fa-2x"></i
        ></b-col>
        <b-col
          >There has been invoice activity on this order since it was last
          reconciled, the total amount below shows the revised invoiced
          activity.</b-col
        ></b-row
      >
    </b-alert>
    <d-table
      classdivtable="availtable datatable nested"
      refid="invoices_yourref"
      :busy="invoicesyourref.busy"
      :icon="invoicesyourref.icon"
      :tools="invoicesyourref.tools"
      :fields="invoicesyourref.fields"
      :badges="invoicesyourref.badges"
      :items="invoicesyourref.items"
      :downloaded="invoicesyourref.downloaded"
      :showpages="false"
      :selectmode="'single'"
      @select="invoicesyourref_select"
      @click="invoicesyourref_click"
      @totalled="totalled_yourref"
      @load="load"
    ></d-table>
    <div v-if="invoicesyourref.component">
      <component
        :is="invoicesyourref.component"
        :selection="invoicesyourref.selected"
        :config="cconfig"
        @discard="invoicesyourref_click('discard')"
        @refresh="invoicesyourref_click('refresh')"
      ></component>
    </div>
    <div v-if="invoicesother.items.length > 0">
      <b-alert :show="true" variant="warning" class="mt-2 text-center strong">
        Invoices matching search criteria but with other Your Ref/PO
      </b-alert>
      <d-table
        :title="'Invoices matching search criteria but with other Your Ref/PO'"
        classdivtable="availtable datatable nested"
        refid="invoices_other"
        :busy="invoicesother.busy"
        :icon="invoicesother.icon"
        :tools="invoicesother.tools"
        :fields="invoicesother.fields"
        :badges="invoicesother.badges"
        :items="invoicesother.items"
         :downloaded="invoicesyourref.downloaded"
        :showpages="false"
        :selectmode="'single'"
        @select="invoicesother_select"
        @click="invoicesother_click"
        @totalled="totalled_other"
        @load="load"
      ></d-table>
      <div v-if="invoicesother.component">
        <component
          :is="invoicesother.component"
          :selection="invoicesother.selected"
          :config="cconfig"
          @discard="invoicesother_click('discard')"
          @refresh="invoicesother_click('refresh')"
        ></component>
      </div>
    </div>
    <b-card-footer class="mt-2 ml-1">
      <b-row>
        <b-col class="text-left">
          <div v-if="busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
          </div>
          <div v-else>
            <span v-html="message"></span>
          </div>
        </b-col>
        <b-col class="text-right" cols="8">
          <b-button
            squared
            size="sm"
            variant="secondary"
            class="mr-1"
            @click="discard"
          >
            <i class="fa fa-chevron-left pr-1"></i>
            Back
          </b-button>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>


<script>
import gql from "graphql-tag";

import OrderInvoice from "./OrderInvoice";

export default {
  name: "OrdersInvoices",
  components: {
    OrderInvoice,
  },
  async mounted() {
    await this.orderinvoices_load();
  },
  data() {
    return {
      busy: false,
      invoicesyourref: {
        debounce: 500,
        busy: false,
        icon: "fa fa-gbp",
        tools: "go,download,invoice",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "invoiceno",
            label: "Invoice Ref",
            sortable: true,
            class: "text-center",
          },
          {
            key: "refcredit",
            label: "Cr Ref",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "yourref",
            label: "Your Ref/PO",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "dateref",
            label: "Invoice Date",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "vatreclaim",
            label: "rVAT",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "outstanding",
            label: "Balance",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "saletotal",
            label: "Amount",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "credit",
            label: "Type",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-50px",
          },
        ],
        badges: [
          {
            key: "credit",
            type: "badge",
            "Credit Note": "danger",
            Invoice: "primary",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Credit Note";
              } else {
                return "Invoice";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        component: null,
      },
      invoicesother: {
        debounce: 500,
        busy: false,
        icon: "fa fa-gbp",
        tools: "go,download,invoice",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "invoiceno",
            label: "Invoice Ref",
            sortable: true,
            class: "text-center",
          },
          {
            key: "yourref",
            label: "Your Ref/PO",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "dateref",
            label: "Invoice Date",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "outstanding",
            label: "Balance",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "saletotal",
            label: "Amount",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "refcredit",
            label: "Cr Ref",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "credit",
            label: "Type",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-50px",
          },
        ],
        badges: [
          {
            key: "credit",
            type: "badge",
            "Credit Note": "danger",
            Invoice: "primary",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Credit Note";
              } else {
                return "Invoice";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        component: null,
      },
      unreconciled: false,
    };
  },
  methods: {
    async orderinvoices_load() {

      let state = this.invoicesyourref;

      state.busy = true
      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders($id: String, $dateformat: String) {
              orders(id: $id, dateformat: $dateformat) {
                id
                value
                invoices_yourref {
                  id
                  invoiceno: ref
                  credit
                  dateref
                  yourref
                  slac
                  eventcode
                  datetravel
                  vatreclaim
                  saletotal
                  outstanding
                  refcredit
                  dateref
                  datepaid
                }
                invoices_other {
                  id
                  invoiceno: ref
                  credit
                  dateref
                  yourref
                  slac
                  eventcode
                  datetravel
                  saletotal
                  outstanding
                  refcredit
                  dateref
                  datepaid
                }
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.unreconciled = false;
        this.invoicesyourref.items = response.data.orders[0].invoices_yourref;
        this.invoicesother.items = response.data.orders[0].invoices_other;
      } catch (error) {
        console.log(error);
      }
      state.busy = false

    },
    totalled_yourref(e) {
      console.log("totalled_yourref", e);
      let saletotal = e.find((k) => k.key == "saletotal");
      if (saletotal.total) {
        let value = saletotal.total.replace(/,/g, "");
        if (value == this.selection[0].spent) {
          this.unreconciled = false;
        } else {
          this.unreconciled = true;
        }
      }
    },
    totalled_other(e) {
      console.log("totalled_other", e);
      // let saletotal = e.find((k) => k.key == "saletotal");
      // if (saletotal.total) {
      //   let value = saletotal.total.replace(/,/g, "");
      // }
    },

    async invoicesyourref_select(ss, tools) {

      let state = this.invoicesyourref;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["go", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        // enabled = ["deleteconfirm"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = ss.length > 0 ? false : true;
        //   }
        // });

        // if (!state.denied) {
        //   state.denied = [];
        // }
        // state.denied.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.visible = false;
        //   }
        // });
      }
    },
    async invoicesyourref_click(a, ss) {
      console.log("invoicesyourref_click", a, ss);

      let state = this.invoicesyourref;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.invoicesyourref.component = null;
          this.invoicesyourref.busy = true;
          await this.orderinvoices_load();
          this.invoicesyourref.busy = false;
          break;

        case "invoice":
          // this.component = "OrderInvoice";
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.invoicesyourref.component = "OrderInvoice";
            } else {
              this.invoicesyourref.component = null;
            }
          }

          break;
      }
    },

    async invoicesother_select(ss, tools) {

      let state = this.invoicesother;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["go", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        // enabled = ["deleteconfirm"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = ss.length > 0 ? false : true;
        //   }
        // });

        // if (!state.denied) {
        //   state.denied = [];
        // }
        // state.denied.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.visible = false;
        //   }
        // });
      }
    },
    async invoicesother_click(a, ss) {
      console.log("invoicesother_click", a, ss);

      let state = this.invoicesother;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.invoicesother.component = null;
          state.busy = true;
          await this.load();
          state.busy = false;
          break;
        case "invoice":
          // this.component = "OrderInvoice";

          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.invoicesother.component = "OrderInvoice";
            } else {
              this.invoicesother.component = null;
            }
          }

          break;
      }
    },
  },
};
</script>

<style>
</style>